import classNames from "classnames";
import { get } from "lodash";
import { MdDraw } from "react-icons/md";
import Button from "shared/components/Button";
import { CURRENCY_SYMBOL } from "utils/constants";

const formatCost = (value) => Number(value || 0).toFixed(2);

const CombinationCard = ({
  combination,
  action,
  translation,
  selected = false,
}) => {
  const baseInsurancePlan = get(combination, "baseInsurancePlan");
  const complementaryInsurancePlan = get(
    combination,
    "complementaryInsurancePlan",
  );
  const symbol = CURRENCY_SYMBOL[combination.currency] || "";
  const total = formatCost(combination.totalCost);
  const [integer, decimal = ""] = total.split(".");

  return (
    <div
      className={classNames("insurance-plan", "combination-card", {
        "combination-card--selected": selected,
      })}
    >
      {get(baseInsurancePlan, "icon") && (
        <img
          className="insurance-plan__icon"
          src={baseInsurancePlan.icon}
          alt={get(baseInsurancePlan, "name", "")}
        />
      )}
      <div className="insurance-plan__title">
        {combination.label}
        <div className="insurance-plan__title--light">
          {complementaryInsurancePlan
            ? `Socle avec ${get(complementaryInsurancePlan, "name", "")}`
            : "Socle seul"}
        </div>
      </div>
      <div className="insurance-plan__bottom">
        <div className="insurance-plan__cost">
          <span className="insurance-plan__cost--integer">
            {`${integer} ${symbol} `}
            <span className="insurance-plan__cost--decimal">{decimal}</span>
          </span>
          <span className="insurance-plan__cost--period">
            {` /${get(translation, "MONTH", "mois")}`}
          </span>
        </div>
        <div className="combination-card__detail">
          <div>
            <span>{get(baseInsurancePlan, "name", "—")}</span>
            <span>
              {formatCost(combination.baseCost)} {symbol}
            </span>
          </div>
          {complementaryInsurancePlan && (
            <div>
              <span>{get(complementaryInsurancePlan, "name", "—")}</span>
              <span>
                {formatCost(combination.complementCost)} {symbol}
              </span>
            </div>
          )}
        </div>
        {action && (
          <div className="popover-wrapper">
            <Button
              type="secondary"
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.label}
              <MdDraw size={16} />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CombinationCard;
